<div class="carousel-wrapper">
  <ng-container *ngIf="!showContent">
    <div class="carousel-container">
      <owl-carousel-o [options]="carouselOptions">

        <ng-template carouselSlide *ngFor="let item of carouselItems">
          <div class="caption-container">
            <h4 class="caption-heading">{{ item.heading }}</h4>
            <p class="caption-text "><strong>{{ item.caption }}</strong></p>
          </div>
          <div class="item-container">
            <div class="image-container">
              <img [src]="item.image" class="carousel-img">

            </div>

          </div>

        </ng-template>

      </owl-carousel-o>

    </div>
    <div class="land-buttons ">
      <div class="captions mt-4">
        <span>
          <p class=" welcometext  mb-2">Welcome to</p>
        </span>
        <span>
          <p class="welcomecaption  mb-2">MyFoodGenie</p>
        </span>
      </div>




      <div class="loginmethod mt-4">
        <p class="login_signup">Login / Signup</p>
        <div class="flex justify-content-between">
          <div class="login-button mr-4" role="button" style="border-radius: 29px !important;" (click)="onSignUp()">
            Personal</div>
          <!-- <button class="orange-button" type="button" (click)="OnCorporcateClick()">Corporate</button> -->
        </div>
      </div>
      <div class="terms-container">
        <p class="align-self-center pl-1 terms" style="margin: 0px !important;">
          By signing up, you are agreeing to our
        </p>
        <a class="align-self-center pl-1 condition" style="margin: 0px !important;" (click)="OnAboutPress()">
          Terms and Conditions
        </a>
      </div>

    </div>
    <!-- <div class="land-buttons" style="gap:1rem">
          <div class="orange-button" style="border-radius: 15px !important;" (click)="OnAboutPress()">About us</div>
          <button class="green-button" style="border-radius: 15px !important;" type="button" (click)="onSignUp()" >Signup/Login</button>

          <button class="orange-button" style="border-radius: 15px !important;" (click)="OpenScanner(scanPopup)">Scan Your Orders</button>
         
          
          
      </div> -->







    <!-- <div *ngIf="loggeedUser$ | async as loggeedUser" class="profile-container">
        <div class="avatar">
          <img [src]="loggeedUser.picture" [alt]="loggeedUser.name" />
        </div>
        <h2>{{ loggeedUser.name }}</h2>
        <p>{{ loggeedUser.email }}</p>
      </div> -->
    <!-- <div class="container mt-2">
        <p>Have an Account? <a routerLink="">Login</a></p>
      </div> -->
  </ng-container>
  <ng-container *ngIf="showContent">
    <!-- Content to display when Sign Up button is clicked -->

    <div class="scroll-container">

      <div>

        <div class="container mt-4">
          <!-- Your Sign Up content goes here -->
          <button mat-icon-button class="mr-auto" (click)="onback()">
            <mat-icon>keyboard_backspace</mat-icon>
          </button>
          <h4 class="signup-heading mt-1 " *ngIf="isLogin"><strong>Login</strong></h4>
          <h4 class="signup-heading mt-1 " *ngIf="isCorporateLogin"><strong>Corporate Login</strong></h4>

          <button *ngIf="isCorporateLogin" type="button" class="close" aria-label="Close" (click)="onCorporateClose()">
            <span aria-hidden="true">&times;</span>
          </button>

        </div>

        <!-- <mat-tab-group [(selectedIndex)]="selectedTabIndex"> -->


        <div class="signup-container">
          <img src="../../assets/images/genieImages/loginscreen.svg" alt="Personal Image" class="tab-image">
        </div>
      </div>
      <div class="loginmobile">
        <form *ngIf="!isCorporateLogin" class="userform flex-col flex-auto p-6 pt-10 sm:p-8 sm:pt-10 overflow-y-auto "
          [formGroup]="userForm">
          <div class="form-group MobileNumber" *ngIf="isMobile">
            <label for="validationCustom02" class="mb-1 mobilelabel"><strong>
                Mobile Number </strong></label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">+91</span>
              </div>
              <input class="form-control" formControlName="mobileNumber" placeholder="Mobile Number" type="number" />

            </div>
            <span class="text-danger font-weight-bold" *ngIf="!isMobileValid">Mobile Number is Invalid</span>
          </div>
          <div *ngIf="isNewUser">
            <div class="form-group mobilelabel MobileNumber">
              <label for="validationCustom02" class="mb-1">
                <strong> Name:</strong> </label>
              <input class="form-control" formControlName="fName" placeholder="Name" type="text" />
            </div>
            <div class="form-group mb-2 mobilelabel MobileNumber" *ngIf="isNewUser">
              <label for="validationCustom02" class="mb-1">
                <strong>Email:</strong> </label>
              <input class="form-control" formControlName="email" placeholder="Email Optional" type="text" />
              <!-- <span class="mb-1 text-danger font-weight-bold" *ngIf="!isEmailValid">Invalid Format/Wrong Email Id</span> -->

            </div>

            <div class="form-group mb-2" *ngIf="isOtpSent">
              <label for="" class="mb-1 newuserotplabel"><strong>Enter 4 Digit OTP</strong></label>
              <ng-otp-input #ngOtpInput formControlName="otp" (onInputChange)="onOtpChange($event)" [config]="{ length: 4 ,
                allowNumbersOnly: true,
                inputStyles: {
                'width': '39px',
                'height': '50px',
                'border-radius': '12px'
              }}" name="otp"></ng-otp-input>

              <p class="mb-2 Resendotp" *ngIf="isOtpSent && timeLeft >0">Resend OTP in <strong>{{timeLeft}}</strong>
                Seconds</p>
              <span class="mb-1 text-danger font-weight-bold" *ngIf="isOtpSent && !isOtpVerified && isSubmitted">Wrong
                OTP Entered</span>
              <a class="cursor-pointer mb-2" *ngIf="timeLeft ==0" (click)="resendOTP()">Resend OTP</a>

            </div>
          </div>
          <div class="form-group" *ngIf="isOtpSent && !isNewUser">

            <div class="Mobileverify">
              <label for="" class="mb-1 otplabel"><strong>Enter 4 Digit OTP</strong></label>
              <!-- <P class="otpnumber">+91 - {{Mobilenumber}}</P> -->
            </div>
            <div>
              <div class="otpvalue">
                <ng-otp-input #ngOtpInput formControlName="otp" (onInputChange)="onOtpChange($event)"
                  class="custom-otp-input" [config]="{ length: 4 ,
                    allowNumbersOnly: true,
                    inputStyles: {
                    'width': '39px',
                    'height': '55px',
                    'border-radius': '12px'
                   
                  }}" name="otp"></ng-otp-input>
              </div>
              <p class=" Resendotp" *ngIf="isOtpSent && timeLeft >0">Resend OTP in <strong>{{timeLeft}}</strong> Seconds
              </p>
              <span class="mb-1 text-danger font-weight-bold" *ngIf="isOtpSent && !isOtpVerified && isSubmitted">Wrong
                OTP Entered</span>
              <a class="cursor-pointer mb-2 resendotplabel" *ngIf="timeLeft ==0" (click)="resendOTP()">Resend OTP</a>
            </div>
          </div>


          <!-- New User code below -->


          <div class="sign-up-form-genie" *ngIf="isNewUser">
            <!-- <div class="form-group mb-3">
                  <label for="validationCustom02" class="mb-1">
                      First Name:</label
                  >
                  <input
                      class="form-control"
                      formControlName="fName"
                      placeholder="First Name"
                      type="text"
                  />
              </div>
              <div class="form-group mb-2">
                <label for="validationCustom02" class="mb-1">
                     Email:</label
                >
                <input
                    class="form-control"
                    formControlName="email"
                    placeholder="Email Optional"
                    type="text"
                />
               <span class="mb-1 text-danger font-weight-bold" *ngIf="!isEmailValid">Invalid Format/Wrong Email Id</span>
  
            </div> -->
            <!-- <div class="form-group mb-2" *ngIf="isOtpSent">
              <label for="" class="mb-1">Enter 4 Digit OTP</label>
              <ng-otp-input
              #ngOtpInput
                formControlName="otp"
                (onInputChange)="onOtpChange($event)"
                [config]="{ length: 4 ,
                  allowNumbersOnly: true,
                  inputStyles: {
                  'width': '39px',
                  'height': '50px',
                  'border-radius': '12px'
                }}"
                name="otp"
              ></ng-otp-input>

              <p class="mb-2 Resendotp" *ngIf="isOtpSent && timeLeft >0">Resend OTP in <strong>{{timeLeft}}</strong> Seconds</p>
              <span class="mb-1 text-danger font-weight-bold" *ngIf="isOtpSent && !isOtpVerified && isSubmitted">Wrong OTP Entered</span>
              <a  class="cursor-pointer mb-2" *ngIf="timeLeft ==0">Resend OTP</a>
             
            </div> -->

          </div>
        </form>
        <!-- corporate login -->
        <div *ngIf="isCorporateLogin" class="corporate">

          <!-- <div class="signup-container">
                    <img  src="./assets/images/genieImages/signup_corporate_img.png"  alt="Corporate Image" class="tab-image">
                  </div> -->
          <div class="form-group mt-3 justify-content-between">
            <label for="validationCustom02" class="mb-1 corporatelabel">
              Enter your corporate code:</label>
            <div class="flex-container">
              <input class="form-control corporateinput" [(ngModel)]="stallCode" placeholder="Corporate Code"
                type="text" />
              <p class="ortext">or</p>

              <div class="qrimage">

                <img src="../../assets/images/genieImages/new_qricon.svg" (click)="OpenScanner(scanPopup)"
                  class="qrscannerimage">
                <p class="scan">scan</p>
              </div>
            </div>

            <span class="mb-1 text-danger font-weight-bold" *ngIf="isStallCodeValid =='invalid'">Invalid Code</span>
          </div>
          <div class="container">
            <button class="continue mt-2" style="border-radius: 15px !important"
              (click)="checkOrganisation()">Continue</button>
          </div>

        </div>
        <div class="container mb-2" *ngIf="isNewUser && isOtpSent">
          <input type="checkbox" [(ngModel)]="isConditionsAccepted" class="form-check">
          <p class="align-self-center pl-1" style="margin: 0px !important;">By signing up, you are agreeing to our <a
              class="cursor-pointer">Terms and Conditions</a></p>
        </div>
        <div class="container">
          <button class="continue mt-2" style="border-radius: 22px !important"
            *ngIf="!isNewUser && !isOtpSent && !isCorporateLogin" (click)="verifyMobileNumber()">Continue</button>
          <button class="verify" style="border-radius: 22px !important" *ngIf="!isNewUser && isOtpSent"
            (click)="verifyOTP()">Verify & Continue</button>
          <!-- <button class="continue" style="border-radius: 15px !important" *ngIf="!isNewUser && isOtpSent" (click)="verifyOTP()">Login</button>    -->
          <button class="continue mt-2" style="border-radius: 22px !important" *ngIf="isNewUser && !isOtpSent"
            (click)="getOTP()">Continue</button>
          <button type="submit" class="continue" style="border-radius: 22px !important" *ngIf="isNewUser && isOtpSent"
            [disabled]="!isConditionsAccepted" (click)="verifyOTP()">Register</button>
        </div>


      </div>





      <div class="mt-15 loginterms-container" *ngIf="!isNewUser && !isOtpSent &&!isCorporateLogin">
        <p class="align-self-center pl-1 loginscreenterms" style="margin: 0px !important;">
          By signing up, you are agreeing to our
        </p>
        <p class="align-self-center pl-1 condition" style="margin: 0px !important;">
          <a class="cursor-pointer condition" (click)="OnAboutPress()">Terms and Conditions</a>
        </p>
      </div>





    </div>
  </ng-container>
</div>
<ng-template #scanPopup>
  <div class="modal-header">
    <h5 class="modal-title f-w-600" id="exampleModalLabel">Scan</h5>
    <button type="button" class="close" aria-label="Close" (click)="OnClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="scanner-container absolute inset-0 flex flex-col min-w-0 overflow-hidden">

      <qr-scanner #qrscanner (capturedQr)="capturedQr($event)" [texts]="{
                NotSupportedHTML: 'You are using an outdated browser',
                DeviceDefaultPrefix: 'Camera',
                StopCameraText: 'Stop Camera',
                OpenButtonText: 'Open QR Code File...'}" [buttonClass]="ngClassForButtons" [allowUpload]="true"
        (error)="onError($event)">

      </qr-scanner>


      <div *ngIf="isContainerVisible" class="rectangle-overlay">
        <div class="line" [style.top.%]="linePosition"></div>
      </div>
    </div>
  </div>

  <div class="whitebackground mt-1 mb-1">
    <!-- <div>
                <input type="text" placeholder="Enter OrderId/Mobile number" class="w-100" [(ngModel)]="qrCodeResult"/>
            </div> -->

    <div *ngIf="qrCodeResult && qrCodeResult!=''">
      <div class="full-container" *ngIf="orderDetails?.orderStatus!='Delivered' &&
               orderDetails?.orderStatus!='Completed';else compBlock">
        <div class="container d-flex" style="gap: 1rem;">

          <div class="column">
            <div class="heading font-weight-bold">Order Id:</div>
            <div class="heading font-weight-bold">Order Date:</div>
            <div class="heading font-weight-bold">Order Status:</div>
            <div class="heading font-weight-bold">Total Amount:</div>
            <div class="heading font-weight-bold">Total Items</div>

            <div class="heading font-weight-bold">Payment:</div>
            <div class="heading font-weight-bold">Mode of Payment:</div>

            <!-- <div class="heading">Delivery Address:</div> -->
            <!-- Add more headings as needed -->
          </div>
          <div class="column">
            <div class="value">{{ orderDetails?.orderId }}</div>
            <div class="value">{{ orderDetails?.orderDateTime | date: 'yyyy-MM-dd HH:mm:ss'}}</div>
            <div class="vallue">{{orderDetails?.orderStatus}}</div>
            <div class="value">{{ orderDetails?.amount }}</div>
            <div class="value">{{orderDetails?.orderItemCount}}</div>
            <div class="value">{{ orderDetails?.paymentStatus }}</div>
            <div class="value">{{ orderDetails?.paymentMode}}</div>

            <!-- <div class="value">{{ orderDetails?.shippingAddressName }}</div> -->
            <!-- Add more values as needed -->
          </div>
        </div>

        <div class=" mt-3 ml-3 mb-3">
          <div class="row font-bold mb-1">
            <!-- Headings -->
            <div class="col"><strong>Item ID/Name</strong></div>
            <div class="col text-center"><strong> Qty </strong></div>
            <div class="col"><strong> Price</strong></div>
          </div>
          <div *ngFor="let orderitems of orderDetails.orderItems" class="row clearfix mb-2">
            <!-- Values -->
            <div class="col">{{ orderitems?.itemName }}-{{
              orderitems?.uom}}</div>
            <div class="col text-center"> {{ orderitems.quantity }}</div>
            <div class="col">{{ orderitems.totalPrice }}</div>
          </div>
        </div>
        <div class="d-flex justify-content-between p-2">
          <button class="btn btn-danger cancel" (click)="OnClose()">Cancel</button>
          <button class="btn btn-primary dispense">Dispense</button>
        </div>
      </div>

    </div>
    <ng-template #compBlock>
      <div class="d-flex justify-content-center">
        <span>
          Order Status: {{orderDetails?.orderStatus}}
        </span>
        <p class="text-danger font-weight-bold" *ngIf="qrCodeResult">Only order status with InProcess or Submitted will
          be shown</p>
      </div>

    </ng-template>

  </div>
</ng-template>
<!-- scan popup -->
<ng-template #scanPopup>
  <div class="modal-header">
    <h5 class="modal-title f-w-600" id="exampleModalLabel">Scan</h5>
    <button type="button" class="close" aria-label="Close" (click)="OnClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="scanner-container absolute inset-0 flex flex-col min-w-0 overflow-hidden">

      <qr-scanner #qrscanner (capturedQr)="capturedQr($event)" [texts]="{
            NotSupportedHTML: 'You are using an outdated browser',
            DeviceDefaultPrefix: 'Camera',
            StopCameraText: 'Stop Camera',
            OpenButtonText: 'Open QR Code File...'}" [buttonClass]="ngClassForButtons" [allowUpload]="true"
        [disableScan]="false" (error)="onError($event)">

      </qr-scanner>


      <div *ngIf="isContainerVisible" class="rectangle-overlay">
        <div class="line" [style.top.%]="linePosition"></div>
      </div>
    </div>
  </div>



</ng-template>
<ng-container>
  <div *ngIf="loading" class="overlay" (click)="overlayClick($event)">
    <mat-spinner></mat-spinner>
  </div>
</ng-container>